import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";

const PartnerAddressesSummary = ({ partnerAddressesSummary }) => {
  const { t } = useTranslation();

  return (
    <div>
      <Grid container spacing={1} pt="1" sx={{ fontSize: "14px" }}>
        <Grid item xs={4} sm={4} md={4}>
          <strong>{t("Partner.Address")}</strong> : <span>{partnerAddressesSummary?.syntheticName}</span>
        </Grid>
      </Grid>
    </div>
  );
};

PartnerAddressesSummary.propTypes = {
  partnerAddressesSummary: PropTypes.object
};

export default PartnerAddressesSummary;
